import { useTheme } from '@mui/material';

import { MenuIconProps } from './menu-icon-props.interface';

export const BenefitMenuIcon = ({
  stroke,
  filled,
  ...props
}: MenuIconProps) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return filled ? (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.47006 3.96973C9.76296 3.67704 10.2378 3.67692 10.5306 3.96973C10.8232 4.26257 10.8232 4.73743 10.5306 5.03027L2.83724 12.7236C2.73992 12.8213 2.73974 12.9796 2.83724 13.0771L8.72982 18.9697L8.78158 19.0264C9.02205 19.321 9.00449 19.7556 8.72982 20.0303C8.45532 20.3046 8.02139 20.322 7.72689 20.082L7.66928 20.0303L1.7767 14.1377C1.09331 13.4543 1.09331 12.3455 1.7767 11.6621L9.47006 3.96973Z"
        fill={strokeColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8997 3.75L21.0277 3.75684C21.6579 3.8209 22.1497 4.35283 22.1497 5V10.8926C22.1497 11.2241 22.0179 11.542 21.7835 11.7764L14.2376 19.3232C14.1556 19.4053 14.0668 19.4767 13.974 19.5391C13.9475 19.5568 13.9201 19.5727 13.8929 19.5889C13.8721 19.6012 13.8516 19.6136 13.8304 19.625C13.8083 19.6369 13.7855 19.6473 13.763 19.6582C13.7334 19.6726 13.7044 19.6876 13.6742 19.7002C13.6539 19.7087 13.6332 19.716 13.6126 19.7236C13.5813 19.7353 13.5498 19.746 13.5179 19.7559C13.4998 19.7615 13.4815 19.7665 13.4632 19.7715C13.4272 19.7813 13.3912 19.7903 13.3548 19.7979C13.3376 19.8014 13.3204 19.8046 13.3031 19.8076C13.2641 19.8144 13.2251 19.8201 13.1859 19.8242C13.1722 19.8257 13.1586 19.827 13.1449 19.8281C13.1091 19.8311 13.0733 19.8332 13.0374 19.834C13.0127 19.8345 12.988 19.8345 12.9632 19.834C12.9329 19.8333 12.9027 19.8313 12.8724 19.8291C12.8502 19.8275 12.8281 19.8257 12.806 19.8232C12.7756 19.8199 12.7454 19.8155 12.7152 19.8105C12.6894 19.8063 12.6636 19.8023 12.638 19.7969C12.6115 19.7913 12.5853 19.7842 12.5589 19.7773C12.5315 19.7702 12.504 19.7633 12.4769 19.7549C12.4565 19.7485 12.4366 19.7406 12.4163 19.7334C12.3834 19.7218 12.3501 19.7109 12.3177 19.6973C12.3067 19.6926 12.2964 19.6865 12.2855 19.6816C12.096 19.5969 11.9175 19.4787 11.762 19.3232L6.5765 14.1377C6.53382 14.095 6.49373 14.0507 6.45639 14.0049C5.89574 13.3175 5.93581 12.3028 6.5765 11.6621L14.1234 4.11621L14.1556 4.08691L14.2142 4.0332C14.4365 3.85098 14.7172 3.75012 15.0072 3.75H20.8997ZM17.5003 7.19922C16.8376 7.19927 16.3001 7.7367 16.3001 8.39941C16.3002 9.06203 16.8377 9.59956 17.5003 9.59961C18.1628 9.59941 18.6994 9.06194 18.6995 8.39941C18.6995 7.73679 18.1629 7.19942 17.5003 7.19922Z"
        fill={strokeColor}
      />
    </svg>
  ) : (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.19998 19.5L2.30708 13.6071C1.91656 13.2166 1.91656 12.5834 2.30708 12.1929L9.99998 4.5M12.2929 18.7929L7.10708 13.6071C6.71656 13.2166 6.71656 12.5834 7.10708 12.1929L14.6535 4.64645C14.7473 4.55268 14.8745 4.5 15.0071 4.5H20.9C21.1761 4.5 21.4 4.72386 21.4 5V10.8929C21.4 11.0255 21.3473 11.1527 21.2535 11.2464L13.7071 18.7929C13.3166 19.1834 12.6834 19.1834 12.2929 18.7929Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.3 8.4002C16.3 9.06294 16.8373 9.6002 17.5 9.6002C18.1628 9.6002 18.7 9.06294 18.7 8.4002C18.7 7.73745 18.1628 7.2002 17.5 7.2002C16.8373 7.2002 16.3 7.73745 16.3 8.4002Z"
        fill={strokeColor}
      />
    </svg>
  );
};
